/*
  The storefront password dialog on the coming-soon page.

  Loaded only when the password entry setting is on, and it is the only script
  the password page has. Everything it does is an upgrade: the dialog already
  opens on :target and closes by clearing the fragment. What the browser gives
  us once showModal() is used, and not before, is the focus trap, Esc, and the
  page behind going inert.
*/
(function () {
  var dialog = document.querySelector('[data-curbi-lock]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  var returnFocusTo = null;

  function open(event) {
    if (event) event.preventDefault();
    if (dialog.open) return;
    returnFocusTo = document.activeElement;
    dialog.showModal();
    var field = dialog.querySelector('input[type="password"]');
    if (field) field.focus();
  }

  function close(event) {
    if (event) event.preventDefault();
    dialog.close();
  }

  var opener = document.querySelector('[data-curbi-lock-open]');
  if (opener) opener.addEventListener('click', open);

  dialog.querySelectorAll('[data-curbi-lock-close]').forEach(function (button) {
    button.addEventListener('click', close);
  });

  // The backdrop is not an element, so a click on it is reported on the dialog
  // itself. Anything inside lands on the panel instead.
  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) dialog.close();
  });

  dialog.addEventListener('close', function () {
    if (returnFocusTo && returnFocusTo.focus) returnFocusTo.focus();
    returnFocusTo = null;
  });

  // A wrong password reloads the page with the error in the markup. Reopening
  // is the whole point — otherwise the message is behind a link nobody knows
  // to click again.
  if (dialog.querySelector('[data-curbi-lock-error]')) open();
})();
